import { getLocalTimeZone } from "@internationalized/date";

export const TIMEZONE = getLocalTimeZone();
